import React, {  useEffect } from "react";
import { useDispatch } from "react-redux";
import { setCardsData} from "../../configureStore";
import Card from "../card/card";
const CardsList = ({ list }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const cards = searchParams.getAll('cards');
    if (cards !== null && cards.length) {
      cards.forEach(card=>{
        dispatch(setCardsData({card:card,type:'add'}))
      })
    }

  }, []);
  return (
    <ul className="cards__list">
      {list.map((card) => {
        return <li className="cards__item" key={card.cardId}>
          <Card card={card} />
        </li>;
      })}
    </ul>
  );
};
export default CardsList;
